import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "../../lib/api";
import { toast } from "sonner";
import { Briefcase, ExternalLink, Trash2, Plus } from "lucide-react";

export default function OwnerVendorsTab({ user }) {
  const [subs, setSubs] = useState([]);
  const load = async () => {
    try { const { data } = await api.get("/vendors/subscriptions/my"); setSubs(data); }
    catch { /* */ }
  };
  useEffect(() => { load(); }, []);

  const cancel = async (sid) => {
    if (!confirm("Cancel this vendor subscription?")) return;
    try { await api.delete(`/vendors/subscriptions/${sid}`); toast.success("Cancelled"); load(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Failed"); }
  };

  const active = subs.filter(s => s.status === "active");
  const monthlySpend = active.reduce((s, x) => s + (x.monthly_fee || 0), 0);

  return (
    <div data-testid="owner-vendors-tab">
      <div className="flex flex-wrap items-center justify-between mb-4">
        <h2 className="font-display font-black text-2xl">Subscribed vendors</h2>
        <Link to="/vendors" className="brut-btn" data-testid="browse-vendors-btn"><Plus size={14}/> Browse marketplace</Link>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
        <div className="brut-card p-4"><div className="brut-tag lime">Active</div><div className="font-display font-black text-4xl mt-2">{active.length}</div></div>
        <div className="brut-card p-4"><div className="brut-tag pink">Total</div><div className="font-display font-black text-4xl mt-2">{subs.length}</div></div>
        <div className="brut-card p-4 bg-[#2ED573]"><div className="brut-tag white">Monthly spend</div><div className="font-display font-black text-3xl mt-2">₹{monthlySpend.toLocaleString()}</div></div>
      </div>

      <div className="space-y-2">
        {subs.length === 0 && (
          <div className="brut-card p-12 text-center">
            <Briefcase size={32} className="mx-auto"/>
            <div className="font-display font-black text-2xl mt-2">No vendors subscribed yet</div>
            <p className="text-[#484848] mt-1">Browse the marketplace to plug tiffin, laundry & wifi vendors into your PG.</p>
            <Link to="/vendors" className="brut-btn mt-4 inline-flex">Open marketplace</Link>
          </div>
        )}
        {subs.map(s => (
          <div key={s.id} className="brut-card p-4 flex flex-wrap items-center justify-between gap-3" data-testid={`owner-sub-${s.id}`}>
            <div className="flex-1 min-w-[200px]">
              <div className="flex items-center gap-2">
                <strong>{s.vendor_name}</strong>
                <span className="brut-tag lime !text-[10px]">{s.vendor_category}</span>
                <span className={`brut-tag ${s.status === "active" ? "lime" : "pink"} !text-[10px]`}>{s.status}</span>
              </div>
              <div className="text-xs text-[#484848] mt-1">{s.property_title} · {s.plan_name} · ₹{s.monthly_fee || 0}/mo · since {s.started_at?.slice(0, 10)}</div>
            </div>
            <div className="flex gap-2">
              <Link to={`/vendors/${s.vendor_id}`} className="brut-btn white !py-1 !px-3 !text-xs" data-testid={`view-vendor-${s.id}`}><ExternalLink size={12}/> View</Link>
              {s.status === "active" && <button className="brut-btn pink !py-1 !px-3 !text-xs" onClick={()=>cancel(s.id)} data-testid={`cancel-sub-${s.id}`}><Trash2 size={12}/> Cancel</button>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
